import enLocale from './en'
import zhLocale from './zh'
import layoutEn from './layout/en'
import layoutZh from './layout/zh'
// 类别检索
import classSearchZh from './classSearch/zh'
import classSearchEn from './classSearch/en'
// 变更申请
import changeRequestZh from './changeRequest/zh'
import changeRequestEn from './changeRequest/en'
// 类别管理
import classListZh from './classList/zh'
import classListEn from './classList/en'
// 模型管理
import drawListZh from './drawList/zh'
import drawListEn from './drawList/en'
// 标识管理
import identifyZh from './identifier/zh'
import identifyEn from './identifier/en'
// 度量单位管理
import unitMeasureZh from './unitMeasureManagement/zh'
import unitMeasureEn from './unitMeasureManagement/en'
// 类别类型
import classTypeZh from './classType/zh'
import classTypeEn from './classType/en'
// 标准列表
import standardListZh from './standardList/zh'
import standardListEn from './standardList/en'
// 标准列表
import standardManageZh from './standardManage/zh'
import standardManageEn from './standardManage/en'
// 数据字典管理
import dictionaryManagementZh from './dictionaryManagement/zh'
import dictionaryManagementEn from './dictionaryManagement/en'
// 数据明细
import dataDetailZh from './dataDetail/zh'
import dataDetailEn from './dataDetail/en'
// common
import commonEn from './common/en'
import commonZh from './common/zh'
// 编码规则
import attributeRuleManageZh from './encodeRule/AttributeRuleManage/zh'
import attributeRuleManageEn from './encodeRule/AttributeRuleManage/en'
import baseRuleManageZh from './encodeRule/baseRuleManage/zh'
import baseRuleManageEn from './encodeRule/baseRuleManage/en'
// 任务配置
import taskManagementZh from './TaskManagement/zh'
import taskManagementEn from './TaskManagement/en'
// 一致性
import attributeUniformityEn from './uniformity/AttributeUniformity/en'
import attributeUniformityZh from './uniformity/AttributeUniformity/zh'
import objRegistrationEn from './uniformity/ObjRegistration/en'
import objRegistrationZh from './uniformity/ObjRegistration/zh'
// 实体对象
import tagZh from './tag/zh'
import tagEn from './tag/en'
// 实体文档
import documentZh from './document/zh'
import documentEn from './document/en'

const messages = {
  en: {
    ...dataDetailEn,
    ...dictionaryManagementEn,
    ...standardListEn,
    ...classTypeEn,
    ...unitMeasureEn,
    ...identifyEn,
    ...drawListEn,
    ...classListEn,
    ...commonEn,
    ...changeRequestEn,
    ...classSearchEn,
    ...layoutEn,
    ...enLocale,
    ...ELEMENT.lang.en,
    ...attributeRuleManageEn,
    ...baseRuleManageEn,
    ...taskManagementEn,
    ...attributeUniformityEn,
    ...objRegistrationEn,
    ...tagEn,
    ...documentEn,
    ...standardManageEn,
  },
  zh: {
    ...dataDetailZh,
    ...dictionaryManagementZh,
    ...standardListZh,
    ...classTypeZh,
    ...unitMeasureZh,
    ...identifyZh,
    ...drawListZh,
    ...classListZh,
    ...commonZh,
    ...changeRequestZh,
    ...classSearchZh,
    ...layoutZh,
    ...zhLocale,
    ...ELEMENT.lang.zhCN,
    ...attributeRuleManageZh,
    ...baseRuleManageZh,
    ...taskManagementZh,
    ...attributeUniformityZh,
    ...objRegistrationZh,
    ...tagZh,
    ...documentZh,
    ...standardManageZh,
  },
}

export default messages
